/*
 *   File : App.js
 *   Author : https://evoqins.com
 *   Description : 
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import { Fragment, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from "js-cookie";

//Custom component
import { Login, SignUp } from "./Container/Auth";
import { Footer, HeaderNavigation, LeftNavigationWidget } from "./Component/Navigation";
import { Dashboard } from "./Container/Dashboard";
import { BasketDetail, CreateSubscription, CreatorDetail, Explore, Invest, Watchlist } from "./Container/Explore";
import { Account, Brokers, ConnectBroker, EditProfile } from "./Container/Accounts";
import { Faq, PrivacyPolicy, RefundPolicy, TermsAnsConditions } from "./Container/Others";
import { BasketOrderDetail, OrderListing } from "./Container/Orders";
import { SIPList } from "./Container/SIP";
import { SubscriptionListing } from "./Container/Subscriptions";
import { PortfolioDetail, PortfolioSummary, PortfolioRebalance, RedeemInvestment } from "./Container/Portfolio";
import CreatorMarketingPage from "./Container/CreatorMarketing/creator-marketing";
import { Loader } from "./Component/Others";
import { APIService } from "./Service";
import { _getProfile } from "./Helper";
import Store from "./Store/store";

// Custom data
const PUBLIC_ROUTES = ["/terms-conditions", "/privacy-policy", "/refund-policy", "/faq"];

function App() {

    const USER_ID = useSelector(state => state.Reducer.USER_ID) || Cookies.get("indvestment_user_id");
    const ACCESS_TOKEN = useSelector(state => state.Reducer.ACCESS_TOKEN) || Cookies.get("indvestment_access_token");
    const dispatch = useDispatch();
    const is_public = PUBLIC_ROUTES.includes(window.location.pathname);

    const [publicRoute, setPublicRoute] = useState(is_public);
    const [creatorRoute, setCreatorRoute] = useState(window.location.pathname === "/creator-detail" ? true : false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (USER_ID) {
            setLoading(true);
            _getProfile(USER_ID).then(() => {
                setLoading(false);
            });

            // _updateAccessToken().then(() => {
            //     _getProfile(USER_ID).then(() => {
            //         setLoading(false);
            //     });
            // })
        }
    }, [USER_ID]);


    useEffect(() => {
        // When we reload the page
        window.addEventListener("load", () => {
            Store.dispatch({ type: "UPDATE_ACCESS_TOKEN", payload: Cookies.get("indvestment_access_token") });
            Store.dispatch({ type: "UPDATE_USER_ID", payload: Cookies.get("indvestment_user_id") });
        })
    }, []);

    useEffect(() => {
        // Removing modal backdrop for all modals when use gesture
        window.addEventListener('popstate', function () {
            if (document.querySelector(".modal-backdrop")) {
                document.querySelector(".modal-backdrop").remove();
                document.body.style.overflow = 'unset';
            };

            if (PUBLIC_ROUTES.includes(this.window.location.pathname) == false) {
                setPublicRoute(false);
            }
        });
    }, [window.location.pathname]);

    const _handlePublicRouter = (is_public) => {
        if (is_public) {
            setPublicRoute(true);
        } else {
            setPublicRoute(false);
        }
    };

    //============ API CALL ==============//
    const _updateAccessToken = async () => {
        let url = "profile/refresh-token";
        let refresh_token = localStorage.getItem("indvestment_refresh_token");
        let data = {
            refresh_token
        };
        const response = await APIService(url, data);


        if (response.status_code === 200) {
            let options = { domain: process.env.REACT_APP_DOMAIN, path: '/', expires: response.data.expires_in / 86400 }; // days
            Cookies.set("indvestment_access_token", response.data.access_token, options);
            dispatch({ type: "UPDATE_ACCESS_TOKEN", payload: response.data.access_token });

            // Updating expiry time
            let token_expiry_time = Date.now() + response.data.expires_in * 1000; // Convert to milliseconds
            Cookies.set('indvestment_token_expiry_time', token_expiry_time, options);
        }

        return response;
    };

    const URLChangeListener = () => {
        const location = useLocation();
        useEffect(() => {
            // When user leaves after connecting broker - Lumpsum invest flow
            if (location.pathname !== '/explore/strategy-detail') {
                localStorage.setItem("indvestment_is_lumpsum_broker", false);
            }
        }, [location]);
    };

    return (
        <Fragment>
            {
                creatorRoute ?
                    <Router>
                        <Routes>
                            <Route path="/creator-detail" element={<CreatorMarketingPage />} />
                        </Routes>
                    </Router>
                    :
                    publicRoute ?
                        <Router>
                            <div className="e-bg-lotion">
                                {/* <div className="position-sticky top-0 start-0 z-3 e-bg-lotion"> */}
                                {/* Header Component */}
                                {/* <HeaderNavigation type={2} /> */}
                                {/* </div> */}
                                <div className="col-12 p-3 p-sm-4">
                                    <Routes>
                                        <Route path="terms-conditions" element={<TermsAnsConditions handlePublicRouter={() => _handlePublicRouter(false)} />} />
                                        <Route path="privacy-policy" element={<PrivacyPolicy handlePublicRouter={() => _handlePublicRouter(false)} />} />
                                        <Route path="refund-policy" element={<RefundPolicy handlePublicRouter={() => _handlePublicRouter(false)} />} />
                                        <Route path="faq" element={<Faq type={2} />} />
                                    </Routes>
                                    <div className="mt-4">
                                        <Footer type={2} handlePublicRouter={() => _handlePublicRouter(true)} />
                                    </div>
                                </div>
                            </div>
                            <Routes>
                                <Route path="/creator-detail" element={<CreatorMarketingPage />} />
                            </Routes>
                        </Router>
                        :
                        // TOKEN ?
                        ACCESS_TOKEN ?
                            <>
                                {
                                    loading ?
                                        <Loader wrapperClassName="min-vh-100 d-flex align-items-center justify-content-center" />
                                        :
                                        <Router>
                                            <URLChangeListener />
                                            <div className="e-bg-lotion">
                                                <div className="position-sticky top-0 start-0 z-index-4">
                                                    {/* Header Component */}
                                                    <HeaderNavigation type={1} />
                                                </div>

                                                <div className="mt-4 min-vh-100 position-relative">
                                                    {/* Update mobile navigation */}
                                                    <div id="left-content"
                                                        className="position-fixed top-100px d-none d-sm-block">
                                                        <LeftNavigationWidget />
                                                    </div>
                                                    <div id="main-content">
                                                        <div className="ms-sm-3 me-sm-4 px-3 px-sm-0">
                                                            <Routes>
                                                                <Route path="/">
                                                                    <Route index element={<Dashboard />} />
                                                                </Route>
                                                                {/* <Route path="*" element={<Navigate to="/" />} /> */}
                                                                <Route path="/explore" >
                                                                    <Route index element={<Explore />} />
                                                                    <Route path="strategy-detail">
                                                                        <Route index element={<BasketDetail />} />
                                                                        <Route path="invest" element={<Invest />} />
                                                                    </Route>
                                                                    <Route path="creator-detail" element={<CreatorDetail />} />
                                                                    <Route path="create-subscription" element={<CreateSubscription />} />
                                                                </Route>
                                                                {/* <Route path="/notifications" element={<Notifications />} /> */}
                                                                <Route path="/watchlist" element={<Watchlist />} />

                                                                <Route path="/portfolio" >
                                                                    <Route index element={<PortfolioSummary />} />
                                                                    {/* <Route path="detail" element={<PortfolioDetail />} /> */}
                                                                    <Route path="detail" >
                                                                        <Route index element={<PortfolioDetail />} />
                                                                        <Route path="redeem" element={<RedeemInvestment />} />
                                                                        <Route path="rebalance" element={<PortfolioRebalance />} />
                                                                    </Route>
                                                                </Route>

                                                                {/* <Route path="basket">
                                                                <Route index element={<BasketList />} />
                                                                <Route path="create-basket" element={<CreateBasket />} />
                                                            </Route> */}

                                                                <Route path="/orders">
                                                                    <Route index element={<OrderListing />} />
                                                                    <Route path="detail" element={<BasketOrderDetail />} />
                                                                </Route>

                                                                <Route path="/sip" element={<SIPList />} />
                                                                <Route path="/subscriptions" element={<SubscriptionListing />} />

                                                                {/* <Route path="/risk-profile">
                                                                <Route index element={<RiskProfiling />} />
                                                                <Route path="summary" element={<RiskSummary />} />
                                                            </Route> */}

                                                                <Route path="/account">
                                                                    <Route index element={<Account handlePublicRouter={() => _handlePublicRouter(true)} />} />
                                                                    <Route path="brokers" element={<Brokers />} />
                                                                    <Route path="connect-broker" element={<ConnectBroker />} />
                                                                    <Route path="edit-profile" element={<EditProfile />} />
                                                                    {/* <Route path="change-pin" element={<ChangePin />} /> */}
                                                                </Route>
                                                                <Route path="/faq" element={<Faq />} />
                                                            </Routes>
                                                        </div>
                                                        <Footer type={1} handlePublicRouter={() => _handlePublicRouter(true)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Router>
                                }
                            </>
                            :
                            // Auth Flow
                            <Router>
                                <div className='e-primary-bg-gradient padding-12px-all'>
                                    <HeaderNavigation type={2} />
                                    <Routes>
                                        <Route path="/" element={<Login />} />
                                        <Route path="/login" element={<Login />} />
                                        <Route path="/signup" element={<SignUp handlePublicRouter={() => _handlePublicRouter(true)} />} />
                                        <Route path="*" element={<Navigate to="/" />} />
                                    </Routes>
                                    <Footer type={2} handlePublicRouter={() => _handlePublicRouter(true)} />
                                </div>
                            </Router>
            }

            <ToastContainer position="bottom-right"
                autoClose={3000}
                bodyClassName="e-toast" />

        </Fragment>
    );
}

export default App;

